'use client'
import dynamic from 'next/dynamic'
import { useMemo } from 'react'

import type { RichTextField } from '@/types/prismic'
import type { HubArticleData, HubChapterData, HubDocument } from '@/types/hub'

const Sidebar = dynamic(() => import('./Sidebar'))
const ArticleContent = dynamic(() => import('./ArticleContent'))
const Breadcrumb = dynamic(() => import('@/components/common/Breadcrumb'))

type DataObject = Record<string, any>
type ArticlePageType = {
  uid: string
  resources: DataObject
  sectionData: HubDocument[] | DataObject
  data: DataObject
  slug: string
  type: string
  linkType?: string
}

function getChapterTitleForUid(sectionData: HubDocument[] | DataObject, uid: string): RichTextField | '' {
  if (!Array.isArray(sectionData)) return ''
  const found = sectionData.find((item: HubDocument) => item.uid === uid)
  const docData = found?.data as HubArticleData | HubChapterData | undefined
  return docData?.title ?? ''
}

const ArticlePage = ({ uid, resources, sectionData, data, slug, type, linkType }: ArticlePageType) => {
  const sidebarTitle = useMemo(() => getChapterTitleForUid(sectionData as HubDocument[], uid), [sectionData, uid])

  return (
    <section className="pb-16" aria-label="Hub article">
      <div className="container">
        <Breadcrumb title={data.data.title[0].text} path={type} pathType="hub" />

        <div className="flex min-h-[700px]">
          <div className="w-[calc(100%-792px)] pr-0 lg:pr-[72px]">
            <Sidebar uid={uid} title={sidebarTitle} resources={resources} slug={slug} linkType={linkType} />
          </div>
          <div className="w-full lg:w-[792px]">
            <ArticleContent data={data} resources={resources} uid={uid} type={type} linkType={linkType} />
          </div>
        </div>
      </div>
    </section>
  )
}

export default ArticlePage
